<template>
    <div class="gp-selected-card">
        <div class="gp-selected-card__description">
            <CardBrand v-if="paymentMethodImage" :brand="paymentMethodImage" />
            <h5 class="card-description">
                {{ googlePaySelectedCardDescription }}
            </h5>
            <button class="change-button" @click="$emit('buttonClicked')">
                {{ $ml.get('change') }}
            </button>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import CardBrand from '@/components/CardBrand.vue';

    export default {
        components: {
            CardBrand,
        },

        props: {
            googlePaySelectedCardDescription: {
                type: String,
                required: true
            }
        },

        methods: {
            handleClick() {
                this.message = 'Button clicked!';
            }
        },

        computed: {
            ...mapGetters({
                selectedPaymentMethod: 'payment/getSelectedPaymentMethod',
            }),

            paymentMethodImage: self =>
                self.selectedPaymentMethod ? self.selectedPaymentMethod.Image : null,
        }
    };
</script>

<style lang='scss' scoped>
    .gp-selected-card {
        padding-bottom: 12px;
        border-bottom: 1px solid #B8C1CC;

        &__logo {
            margin-bottom: 12px;
        }

        &__description {
            display: flex;
            align-items: center;
            position: relative;
            padding: 12px 0;

            .card-brand {
                margin-right: 8px;
            }

            .card-description {
                font-size: 16px;
                font-weight: 500;
                line-height: 11px;
                color: #5C6A7B;
                margin: 0;
                padding: 0;
            }

            .change-button {
                color: #0774E7;
                font-size: 14px;
                font-weight: 600;
                line-height: 10px;
                padding: 12px 16px;
                background-color: transparent;
                cursor: pointer;
                border: none;
                position: absolute;
                top: 50%;
                right: 0;
                transform: translateY(-50%);
                
                &:hover {
                    text-decoration: underline;
                }
            }
        }
        
    }
</style>